"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = schema;

var _createReducer = _interopRequireDefault(require("./createReducer"));

var _createSelector = _interopRequireDefault(require("./createSelector"));

var _createActor = _interopRequireDefault(require("./createActor"));

var _groupBy = _interopRequireDefault(require("./groupBy"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var reservedKeyWords = ['allIds', 'byId', 'version', 'length', 'values', 'by', '_', 'memoize'];

function schema(name, version) {
  var groupByDefs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  // Create object based on the groupBys
  if (_typeof(groupByDefs) !== 'object') {
    throw new Error('GroupBys is supposed to be an object definition');
  }

  var groupBys = groupByDefs ? Object.keys(groupByDefs).map(function (key) {
    if (reservedKeyWords.includes(key)) {
      throw new Error("GroupBy name ".concat(key, " in schema ").concat(name, " is a reserved keyword."));
    }

    return new _groupBy["default"](key, groupByDefs[key]);
  }) : [];
  return {
    name: name,
    getReducer: function getReducer() {
      return (0, _createReducer["default"])(name, version, groupBys);
    },
    getSelector: function getSelector(getState) {
      return (0, _createSelector["default"])(getState, groupBys);
    },
    getActor: function getActor(dispatch) {
      return (0, _createActor["default"])(name, dispatch, groupBys);
    },
    onSave: function onSave(state) {
      return state;
    },
    onRestore: function onRestore(state) {
      if (state === null || state === undefined) return state; // Avoid errors arising due to version incompatibility

      var restoreState = state;
      restoreState._ = state._;
      var changed = false;
      groupBys.forEach(function (groupBy) {
        var prevState = state[groupBy.name];
        var nextState = groupBy.onRestore(prevState);
        restoreState[groupBy.name] = nextState;
        changed = changed || prevState !== nextState;
      });
      return changed ? restoreState : state;
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sharingapples/redux/dist/schema/index.js
// module id = 1349
// module chunks = 2